import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { ACHAccountType } from './ach.account-type.enum';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const AcssBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string().regex(/^\d{7,16}$/, { message: 'Account Number should contain 7 to 16 digits' }),
        institutionNumber: z.string().regex(/^\d{3}$/, { message: 'Institution Number should contain 3 digits' }),
        transitNumber: z.string().regex(/^\d{5}$/, { message: 'Transit Number should contain 5 digits' }),
        accountType: z.string(EnumSchema(ACHAccountType)),
        email: z.string().optional(),
    }),
);

export class AcssBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    institutionNumber: string;
    transitNumber: string;
    accountType: string;
    email?: string;
}
